import memoizeOne from 'memoize-one'

export const commafy = memoizeOne((number?: string | number | null, precision = 0) => {
  const n =
    typeof number === 'string'
      ? parseFloat(parseFloat(number).toFixed(precision))
      : typeof number === 'number'
        ? parseFloat(number.toFixed(precision))
        : null
  return typeof n === 'number' ? n.toLocaleString() : '—'
})

export const toPercent = memoizeOne(
  (number?: number | string | null, precision = 0, nullFallback = '-'): string =>
    `${
      (typeof number === 'number' && !isNaN(number)) || typeof number === 'string'
        ? ((typeof number === 'number' ? number : parseFloat(number)) * 100).toFixed(
            precision,
          )
        : nullFallback
    }%`,
)

interface Range {
  min: number
  max: number
}
export const withinRange = (value: number, range: Range): number => {
  return Math.min(Math.max(value, range.min), range.max)
}
